Barba.Dispatcher.on("transitionCompleted", function () {
    if (document.getElementById("board-archive")) {
        Global.components.push(
                new Vue({
                el: '#board-archive',
                store,
                data: function () {
                    return {
                    }
                },
                computed: {
                    showArchive: {
                        get: function () {
                            return this.$store.getters.showBoardArchive
                        },
                        set: function (newValue) {
                            this.$store.dispatch('setShowBoardArchive', newValue);
                        }
                    }
                },
                mounted: function () {
                },
                methods: {
                },
                created: function () {
                },
                destroyed: function () {
                }
            })
        )
    }
});
